import { authHeaders } from './authService';
import API_BASE from './apiBase';

// all customer reads and writes go through the authenticated, scoped API
const NEW_API_URL = `${API_BASE}/clients`;
const API_URL = NEW_API_URL;

const readError = async (response) => {
  try {
    const body = await response.json();
    if (body?.message) return body.message;
  } catch (e) {
    /* no JSON body */
  }
  return `HTTP error! status: ${response.status}`;
};

export const fetchCustomers = async () => {
  try {
    const response = await fetch(NEW_API_URL, { headers: await authHeaders() });
    if (!response.ok) {
      throw new Error(await readError(response));
    }
    let result = await response.json();
    result = result.clients.map(cli => ({ id: cli.id, ...cli.data }));
    return result;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const createCustomer = async (customer) => {
  try {
    const response = await fetch(NEW_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(await authHeaders()),
      },
      body: JSON.stringify({ id: customer.name.trim(), data: { ...customer } }),
    });
    if (!response.ok) {
      throw new Error(await readError(response));
    }
    // container linking happens server-side in POST /clients now
    return { id: customer.name, ...customer };
  } catch (error) {
    throw new Error(error.message);
  }
};

export const editCustomer = async (customer) => {
  customer.size = customer.size === "3 cubic feet" ? "3 cu yds": customer.size;
  try {
    const response = await fetch(`${API_URL}/${encodeURIComponent(customer.id)}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        ...(await authHeaders()),
      },
      body: JSON.stringify({ id: customer.id, data: { ...customer } }),
    });
    if (!response.ok) {
      throw new Error(await readError(response));
    }
    // container linking happens server-side in PUT /clients/:id now
    return { id: customer.id, ...customer };
  } catch (error) {
    throw new Error(error.message);
  }
};

export const deleteCustomer = async (customerId) => {
  try {
    const response = await fetch(`${API_URL}/${encodeURIComponent(customerId)}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        ...(await authHeaders()),
      },
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return { id: customerId };
  } catch (error) {
    throw new Error(error.message);
  }
};
